
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/12v-lithium-trolling-motor-battery",
      function () {
        return require("private-next-pages/12v-lithium-trolling-motor-battery/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/12v-lithium-trolling-motor-battery"])
      });
    }
  